import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';

export class CurrencyListView extends React.Component<CurrencyListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'displayName',
				title: 'Name',
				dataIndex: 'displayName',
				render: (text, record: CurrencySummary) => <Link to={`/general/currencies/${record.id}`}>{text}</Link>,
			},
			{
				key: 'iso3Name',
				title: 'ISO',
				dataIndex: 'iso3Name'
			},
			{
				key: 'centsCurrency',
				title: 'Cents Currency',
				dataIndex: 'centsCurrency'
			},
			{
				key: 'symbol',
				title: 'Symbol',
				dataIndex: 'symbol'
			},
			{
				key: 'decimalPlaces',
				title: 'Decimal places',
				dataIndex: 'decimalPlaces'
			},
			{
				key: 'format',
				title: 'Format',
				dataIndex: 'format'
			}
		];
		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						//  hideToolbar={ToolbarVisibility.hideFooter | ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hidePagination}
						columns={columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/currencies/list/currency-list.view.tsx